import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelopeOpenText,
  faLocationDot,
  faMobileAndroidAlt,
} from "@fortawesome/free-solid-svg-icons";

import rony from "../../assects/images/rony2.jpg";
import dowanload from "../../assects/icons/dowanload.png";

const PersonalInfoMobile = () => {
  return (
    <>
      <div className="lg:hidden">
        <div className="w-full mb-6 lg:mb-0 mx-auto relative text-center px-6 rounded-[20px] mt-44 lg:mt-0">
          {/* <!-- profile image --> */}
          <img
            src={rony}
            className="w-[240px] absolute left-[50%] transform -translate-x-[50%] h-[240px] drop-shadow-xl mx-auto rounded-[20px] -mt-[140px]"
            alt="about"
          />
          <div className="pt-[100px] pb-8">
            <h2 className="mt-6 mb-1 text-[26px] font-semibold ">
              Mofazzel Hossen
            </h2>
            <h3 className="mb-4 text-[#7B7B7B] inline-block darkk:bg-[#1D1D1D] px-5 py-1.5 rounded-lg darkk:text-[#A6A6A6]">
              Full-stack Developer
            </h3>
            <div className="flex justify-center space-x-3">
              {/* <!-- facebook icon and link --> */}
              <a
                href="https://www.facebook.com/rony688488"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="socialbtn group">
                  <svg
                    className="group-hover:fill-white ease-in duration-200"
                    height={"20px"}
                    fill="#1773EA"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                  >
                    <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
                  </svg>
                </span>
              </a>
              {/* <!-- twitter icon and link --> */}
              <a
                href="https://twitter.com/MdMofazzelhos19"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="socialbtn group ">
                  <svg
                    className="group-hover:fill-white ease-in duration-200"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#1C9CEA"
                    height={"20px"}
                    viewBox="0 0 512 512"
                  >
                    <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" />
                  </svg>
                </span>
              </a>
              {/* <!-- github icon and link --> */}
              <a
                href="https://github.com/moofazzel"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="socialbtn group">
                  <svg
                    className="group-hover:fill-white ease-in duration-200"
                    xmlns="http://www.w3.org/2000/svg"
                    height={"20px"}
                    viewBox="0 0 496 512"
                  >
                    <path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z" />
                  </svg>
                </span>
              </a>
              {/* <!-- linkedin icon and link --> */}
              <a
                href="https://www.linkedin.com/in/mofazzel/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="socialbtn group ">
                  <svg
                    className="group-hover:fill-white ease-in duration-200"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#0072b1"
                    height={"20px"}
                    viewBox="0 0 448 512"
                  >
                    <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" />
                  </svg>
                </span>
              </a>
            </div>
            {/* <!-- personal infomation start --> */}
            <div className="bg-[rgba(255,255,255,0.0)] backdrop-blur-[1px] p-7 rounded-2xl mt-5 border shadow-sm">
              <a
                href="tel:+880 1938 688488"
                className="flex border-b border-[#E3E3E3] darkk:border-[#3D3A3A] pb-2.5"
              >
                <span className="socialbtn text-[#E93B81] shadow-md">
                  <FontAwesomeIcon icon={faMobileAndroidAlt} />
                </span>
                <div className="text-left ml-2.5">
                  <p className="text-xs text-[#44566C] darkk:text-[#A6A6A6]">
                    Phone
                  </p>
                  <p className="">+880 1938 688488</p>
                </div>
              </a>
              <a
                href="mailto:mofazzel444@gmail.com"
                className="flex border-b border-[#E3E3E3] darkk:border-[#3D3A3A] py-2.5"
              >
                <span className="socialbtn bg-whitee darkk:bg-black text-[#6AB5B9] shadow-md">
                  <FontAwesomeIcon icon={faEnvelopeOpenText} />
                </span>
                <div className="text-left ml-2.5">
                  <p className="text-xs text-[#44566C] darkk:text-[#A6A6A6]">
                    Email
                  </p>
                  <p className="">mofazzel444@gmail.com</p>
                </div>
              </a>
              <div className="flex border-b border-[#E3E3E3] darkk:border-[#3D3A3A] py-2.5">
                <span className="socialbtn bg-whitee darkk:bg-black text-[#FD7590] shadow-md">
                  <i className="fa-solid fa-location-dot"></i>
                  <FontAwesomeIcon icon={faLocationDot} />
                </span>
                <div className="text-left ml-2.5">
                  <p className="text-xs text-[#44566C] darkk:text-[#A6A6A6]">
                    Location
                  </p>
                  <p className="">Khulna, Bangladesh </p>
                </div>
              </div>
            </div>
            {/* <!-- personal infomation end--> */}
            {/* <!-- dowanload button --> */}
            <a
              href="https://drive.google.com/file/d/1VzrnrfBzEtD5xwUsXeXQsST-HltP0Qaq/view?usp=sharing"
              className="dowanload-btn hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476]"
            >
              <img className="mr-3" src={dowanload} alt="icon" />
              Download CV
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalInfoMobile;
